import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import AddToCart from "../../Buttons/AddToCart";
import { store } from "./Pages/Store/Store";
import { useContext } from "react";
import ModifyQuantity from "../../Buttons/ModifyQuantity";
import NewAddTocart from "../../Buttons/NewAddTocart";
import { newstore } from "./Pages/Store/newStore";

const HotDeals = ({ selectedProduct, recentProductdet }) => {
  const navigate = useNavigate();
  const { restaurantOpen } = useContext(store);
  const { cartItems, storeStatus, setLoginModalStatus, setModalSide } =
    useContext(newstore);

  const handleProductClick = (product) => {
    navigate(`/product/${product.fld_route}`);
  };

  return (
    <div className="deal">
      <Container className="py-5 my-5">
        <h2>Hot Deals</h2>
        <Row>
          <Col md={4} sm={12}>
            <div className="p-3 border rounded h-100 d-flex flex-column">
              {selectedProduct ? (
                <>
                  <div style={{ flex: "0 0 75%" }}>
                    <img
                      src={selectedProduct.VariantImage}
                      alt={selectedProduct.fld_variantname}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      className="mb-3"
                    />
                  </div>
                  <div className="d-flex flex-column justify-content-center text-center">
                    <h5
                    onClick={() => handleProductClick(selectedProduct)}
                      className="mb-2 text-dark fw-bold card-item-name"
                      style={{ marginTop: "10px" }}
                    >
                      {selectedProduct.fld_variantname}
                    </h5>
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Text className="mb-0 price">
                        ₹{selectedProduct?.fld_website_discount_price}
                      </Card.Text>
                      {(() => {
                        const variantId = selectedProduct?.fld_variantid;

                        const isCart = cartItems?.find(
                          (item) =>
                            String(item.fld_variantid) === String(variantId),
                        );

                        return isCart ? (
                          <ModifyQuantity
                            itemid={variantId}
                            quantity={isCart?.fld_quantity}
                            cartlineid={isCart?.fld_cart_dtl_id}
                          />
                        ) : (
                          <span className="theme-btn cursor-pointer">
                            <NewAddTocart itemid={variantId} />
                          </span>
                        );
                      })()}
                    </div>
                    {/* <p className="mb-2">₹{selectedProduct.fld_website_discount_price}</p>
                    {console.log(selectedProduct.fld_website_discount_price)} */}
                  </div>
                </>
              ) : (
                <p className="text-muted">
                  Select a product to view details here
                </p>
              )}
            </div>
          </Col>

          <Col md={8} sm={12}>
            <Row>
              {recentProductdet.map((product) => {
                const isCart = cartItems.find((val) => {
                  if (val.fld_variantid === product.fld_variantid) {
                    return product;
                  }
                  return false;
                });
                return (
                  <Col
                    md={4}
                    sm={6}
                    xs={6}
                    className="mb-4"
                    key={product.fld_productid}
                  >
                    <Card className="h-100 shadow-sm">
                      <Card.Img
                        className="pt-2"
                        variant="top"
                        src={product.VariantImage}
                        style={{
                          height: "150px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => handleProductClick(product)}
                      />
                      <Card.Body>
                        <div>
                          <div>
                            <Card.Title className="mb-1 product card-item-name" onClick={() => handleProductClick(product)}>
                              {product.fld_variantname}
                            </Card.Title>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <Card.Text className="mb-0 price">
                              ₹{product.fld_website_discount_price}
                            </Card.Text>
                            {isCart ? (
                              <ModifyQuantity
                                itemid={product?.fld_variantid}
                                quantity={isCart.fld_quantity}
                                cartlineid={isCart.fld_cart_dtl_id}
                              />
                            ) : (
                              <span className="theme-btn cursor-pointer">
                                <NewAddTocart itemid={product?.fld_variantid} />
                              </span>
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HotDeals;
